import createSearchModule from './search';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const now = new Date();
const year = now.getFullYear();
const month = now.getMonth();
const date = now.getDate();

export default (name) => ({
  name,
  namespaced: true,
  state: () => ({
    innerModalsOpened: {},
    collapsableExpandedItems: {},
    datePickerCancelled: false,
    locationParams: null,
    isLoading: false,
  }),
  modules: {
    search: createSearchModule({
      pageName: 'opo:search',
    }),
  },
  actions,
  mutations,
  getters: getters({
    minDate: (() => {
      const UTCtoday = new Date(Date.UTC(year, month, date));
      return UTCtoday.toISOString().substring(0, 10);
    })(),
    endDate: (() => {
      const threeYearsFromToday = new Date(Date.UTC(year + 3, month, date));
      return threeYearsFromToday.toISOString().substring(0, 10);
    })(),
    defaultRadius: 100,
  }),
});
